module.exports = __webpack_public_path__ + "0fa13ab8ce732bcc2cded9893a7997eb.pdf";